import React, { useState } from 'react'

import ModalWrapper from 'components/ModalWrapper'
import TextEditor2 from 'components/Form/TextEditor/TextEditor2'
import { lang } from 'utils/helpers'

const MessageModal = props => {
  const { isOpen, toggle, value, onSave } = props
  const [editorValue, setEditorValue] = useState({})
  const [error, setError] = useState('')

  const handleOnSave = () => {
    if (!editorValue.content?.length) {
      setError(lang('dashboard_message-content-cannot-empty'))
      return
    }
    onSave(editorValue)
    toggle()
  }

  return (
    <ModalWrapper
      isOpen={isOpen}
      toggle={toggle}
      header={lang('dashboard_message')}
      body={
        <TextEditor2
          cols={5}
          rows={7}
          minHeight={180}
          maxHeight={180}
          placeholder={`${lang('dashboard_type-something')}...`}
          options={['emojis']}
          value={value || editorValue.content || editorValue.contentHtml || ''}
          onChange={data => {
            if (error) setError('')
            setEditorValue({
              content: data.value,
              contentHtml: data.valueHtml
            })
          }}
        />
      }
      eventBtnTxt={lang('dashboard_save')}
      eventBtn={handleOnSave}
      cancelBtnTxt={lang('dashboard_cancel')}
      cancelBtn={toggle}
      error={error}
    />
  )
}

export default MessageModal
